import { IModalErroApi } from "#/contextProver/ContextProverModel";
import { Modal } from "@sicredi/react";

export const ModalErroApi = ({
  messageErro,
  isOpenModal,
  setIsOpenModal,
}: IModalErroApi) => {
  return (
    <Modal
      title="Ops!"
      onClose={() => setIsOpenModal(false)}
      show={isOpenModal}
      primaryButton={{
        children: "OK",
        onClick: () => setIsOpenModal(false),
      }}
    >
      {messageErro}
    </Modal>
  );
};
